<script setup lang="ts">
import { useVModel } from '@vueuse/core';

import { useExposeCustomModalDialogApi } from './bootstrap-modal';
import BootstrapModal from './bootstrap-modal.vue';
import type { DefaultConfirmationArgs } from './confirmation-dialog';

const props = defineProps<{
    modelValue?: boolean;
    message?: string;
    cancel?: boolean;
}>();
//eslint-obsolete no-spaced-func
const emit = defineEmits<{
    (event: 'update:modelValue', value: boolean | undefined): void;
    (event: 'update:message', value: string | undefined): void;
    (event: 'update:cancel', value: boolean | undefined): void;
    (event: 'after-submit', value: undefined): void;
}>();
const showDialog = useVModel(props, 'modelValue', emit, { passive: true });
const _message = useVModel(props, 'message', emit, { passive: true });
const _cancel = useVModel(props, 'cancel', emit, { passive: true });

const [confirmApi, modalApi] = useExposeCustomModalDialogApi<[DefaultConfirmationArgs]>({
    onBeforeShow(args) {
        _message.value = args?.message;
        _cancel.value = args?.cancel ?? false;
    },
});
defineExpose(confirmApi);

</script>

<template>
    <BootstrapModal
        ref="modalApi"
        v-model:model-value="showDialog"
        ok
        oktype="button"
        :cancel="_cancel"
        :close="_cancel"
        @after-submit="emit('after-submit', undefined)"
    >
        <slot>
            <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <div class="alert alert-info" role="alert" style="white-space: pre-line;">{{ _message }}</div>
        </slot>
    </BootstrapModal>
</template>
